import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import { formatCurrency } from "../utils/FormatCurrency"
import { addDays, format } from "date-fns"

function DialogConfirmacaoDias(props){
    //const [checkedConfirmaDias,setCheckedConfirmaDias] = useState(false)

    function aceiteFooter(){
        return(
            <div>
                {/* <div className="loginCheckbox" style={{textAlign:"center"}}>
                    <Checkbox
                        inputId="binary"
                        className="loginCheckbox pb-[23px]"
                        checked={checkedConfirmaDias}
                        onChange={(e) => setCheckedConfirmaDias(e.checked)}
                        />
                    <label htmlFor="binary" className="text-[2vh]">
                        Concordo com os termos de negociação
                    </label>
                </div> */}
                <div className="mt-[1vh] paymentButton w-full grid px-[20px]">
                    <Button label="Gerar Boleto" style={{fontFamily:'Branding-Regular, serif'}} onClick={()=>{props.close();props.aceite()}} />
                </div>
            </div>
        )
    }

    return(
    <div className='boletosDialog'>
        <Dialog
        visible
        className='boletosDialog' 
        onHide={()=>props.close()}
        style={{
            minHeigth:'30vw', 
            minWidth: '40vw', 
            textAlign: 'center',
            fontFamily:'Branding-Regular, serif'
        }}
        draggable={false}
        header="Realizar Negociação"
        footer={aceiteFooter}
        >
            <div>
                <div>
                <h6>Confira as informações de negociação</h6>
                </div>
                <div className="boletosDialog mt-[1vh]">
                    {props.cronograma[0].dia_pagamento === format(addDays(new Date(),1),'dd/MM/yyyy') &&
                        <h5 className="font-branding-bold text-red-500">O {props.cronograma.length !== 1 
                        && 'primeiro'} boleto vence amanhã!</h5>}
                    <h5 className="font-branding-bold mt-[3vh] mb-[1vh]">Cronograma de pagamento</h5>
                    <DataTable 
                    value = {props.cronograma}
                    className="boletosDialog overflow-auto h-[30vh]"
                    >
                        <Column field="parcela" header="Parcela" className="font-branding-bold" />
                        <Column field="valor" header="Valor Parcela" className="font-branding-bold" />
                        <Column field="dia_pagamento" header="Data Vencimento" className="font-branding-bold" />
                    </DataTable>
                </div>
                <div className="mt-[1vh]">
                    <h5 className="font-branding-bold">Total a Pagar</h5>
                    <h4 className="font-branding-bold">{formatCurrency(props.valor_pagamento)}</h4>
                </div>
            </div>
        </Dialog>
    </div>
    )
}

export default DialogConfirmacaoDias